import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'reports.generalPanelTRI.title',
    defaultMessage: 'GENERAL PANEL TRI',
  },
  back: {
    id: 'reports.generalPanelTRI.back',
    defaultMessage: 'Back',
  },
  school: {
    id: 'reports.generalPanelTRI.school',
    defaultMessage: 'School',
  },
  class: {
    id: 'reports.generalPanelTRI.class',
    defaultMessage: 'Class',
  },
  application: {
    id: 'reports.generalPanelTRI.application',
    defaultMessage: 'Application',
  },
  chain: {
    id: 'reports.generalPanelTRI.chain',
    defaultMessage: 'chain',
  },
  students: {
    id: 'reports.generalPanelTRI.students',
    defaultMessage: 'Students',
  },
  generatePdf: {
    id: 'reports.generalPanelTRI.generatePdf',
    defaultMessage: 'Download PDF',
  },
  countStudents: {
    id: 'reports.generalPanelTRI.countStudents',
    defaultMessage: 'Total participants',
  },
  schoolPositon: {
    id: 'reports.generalPanelTRI.schoolPositon',
    defaultMessage: 'School position in the evaluation',
  },
  groupPosition: {
    id: 'reports.generalPanelTRI.groupPosition',
    defaultMessage: 'Class position in the evaluation',
  },
  avgGradeGroup: {
    id: 'reports.generalPanelTRI.avgGradeGroup',
    defaultMessage: 'Class average grade',
  },
  MaxGradeGroup: {
    id: 'reports.generalPanelTRI.MaxGradeGroup',
    defaultMessage: 'Class max grade',
  },
  MinGradeGroup: {
    id: 'reports.generalPanelTRI.MinGradeGroup',
    defaultMessage: 'Class min grade',
  },
  avgGradeWriting: {
    id: 'reports.generalPanelTRI.avgGradeWriting',
    defaultMessage: 'Writing average grade',
  },
  MaxGradeWriting: {
    id: 'reports.generalPanelTRI.MaxGradeWriting',
    defaultMessage: 'Writing max grade',
  },
  MinGradeWriting: {
    id: 'reports.generalPanelTRI.MinGradeWriting',
    defaultMessage: 'Writing min grade',
  },
  generalReport: {
    id: 'reports.generalPanelTRI.generalReport',
    defaultMessage: 'General Report',
  },
  studentReport: {
    id: 'reports.generalPanelTRI.studentReport',
    defaultMessage: '{studentName} Report',
  },
  studentEvaluationPosition: {
    id: 'reports.generalPanelTRI.studentEvaluationPosition',
    defaultMessage: 'Student position in the evaluation',
  },
  studentGroupPosition: {
    id: 'reports.generalPanelTRI.studentGroupPosition',
    defaultMessage: 'Student position in the class',
  },
  studentSchoolPosition: {
    id: 'reports.generalPanelTRI.studentSchoolPosition',
    defaultMessage: 'Student position at school',
  },
  studentAvg: {
    id: 'reports.generalPanelTRI.studentAvg',
    defaultMessage: 'Student Average Grade',
  },
  gradeLC: {
    id: 'reports.generalPanelTRI.gradeLC',
    defaultMessage: 'Grade in LC',
  },
  gradeCH: {
    id: 'reports.generalPanelTRI.gradeCH',
    defaultMessage: 'Grade in CH',
  },
  gradeCN: {
    id: 'reports.generalPanelTRI.gradeCN',
    defaultMessage: 'Grade in CN',
  },
  gradeMT: {
    id: 'reports.generalPanelTRI.gradeMT',
    defaultMessage: 'Grade in MT',
  },
  gradeWriting: {
    id: 'reports.generalPanelTRI.gradeWriting',
    defaultMessage: 'Grade in Writing',
  },
  heatMapStudentsPerformance: {
    id: 'reports.generalPanelTRI.heatMapStudentsPerformance',
    defaultMessage: 'Heat map of student performance',
  },
  comparativePerformanceByArea: {
    id: 'reports.generalPanelTRI.comparativePerformanceByArea',
    defaultMessage: 'Comparative performance by area',
  },
  bubbleChartHeats: {
    id: 'reports.generalPanelTRI.bubbleChartHeats',
    defaultMessage: 'Bubble chart heats per student',
  },
  bubbleChartHeatsByArea: {
    id: 'reports.generalPanelTRI.bubbleChartHeatsByArea',
    defaultMessage: 'Bubble chart heats by area',
  },
  heatQuestionsMap: {
    id: 'reports.generalPanelTRI.heatQuestionsMap',
    defaultMessage: 'Heat questions map',
  },
  score: {
    id: 'reports.generalPanelTRI.score',
    defaultMessage: 'Score',
  },
  studentsNumber: {
    id: 'reports.generalPanelTRI.studentsNumber',
    defaultMessage: 'Students number',
  },
  performanceComparison: {
    id: 'reports.generalPanelTRI.performanceComparison',
    defaultMessage: 'Comparison of performance by school classes x student',
  },
  comparisonOfAverageScoreByApplication: {
    id: 'reports.generalPanelTRI.comparisonOfAverageScoreByApplication',
    defaultMessage: 'Comparison of average score by application',
  },
  studentName: {
    id: 'reports.generalPanelTRI.avgRankingTable.studentName',
    defaultMessage: 'Student name',
  },
  filename: {
    id: 'reports.generalPanelTRI.avgRankingTable.filename',
    defaultMessage: 'averageGrade',
  },
  tabname: {
    id: 'reports.generalPanelTRI.avgRankingTable.tabname',
    defaultMessage: 'Average Grade',
  },
  avg: {
    id: 'reports.generalPanelTRI.avgRankingTable.avg',
    defaultMessage: 'Average',
  },
  objective: {
    id: 'reports.generalPanelTRI.avgRankingTable.objective',
    defaultMessage: 'Objective',
  },
  writing: {
    id: 'reports.generalPanelTRI.avgRankingTable.writing',
    defaultMessage: 'Writing',
  },
  avgObj: {
    id: 'reports.generalPanelTRI.avgRankingTable.avgObj',
    defaultMessage: 'Objective Average',
  },
  selectOptionsAbove: {
    id: 'reports.generalPanelTRI.selectOptionsAbove',
    defaultMessage: 'Please select the options above to upload the report',
  },
  performanceComparisonByAreaStudentXApp: {
    id: 'reports.generalPanelTRI.performanceComparisonByAreaStudentXApp',
    defaultMessage: 'Performance comparison by area Student VS Application',
  },
  avgByAreaMessage: {
    id: 'reports.generalPanelTRI.avgByAreaMessage',
    defaultMessage: 'Average',
  },
  question: {
    id: 'reports.generalPanelTRI.question',
    defaultMessage: 'Question',
  },
  avgGradeSchool: {
    id: 'reports.generalPanelTRI.avgGradeSchool',
    defaultMessage: 'School average grade',
  },
  MaxGradeSchool: {
    id: 'reports.generalPanelTRI.MaxGradeSchool',
    defaultMessage: 'School max grade',
  },
  MinGradeSchool: {
    id: 'reports.generalPanelTRI.MinGradeSchool',
    defaultMessage: 'School min grade',
  },
  schoolCountStudents: {
    id: 'reports.generalPanelTRI.schoolCountStudents',
    defaultMessage: 'Total participating schools',
  },
  amountOfHits: {
    id: 'reports.generalPanelTRI.amountOfHits',
    defaultMessage: 'Amount of hits',
  },
  scoreTRI: {
    id: 'reports.generalPanelTRI.scoreTRI',
    defaultMessage: 'Score TRI',
  },
  lineBubbleLabel: {
    id: 'reports.generalPanelTRI.lineBubbleLabel',
    defaultMessage: 'Line: Number of questions',
  },
  columnBubbleLabel: {
    id: 'reports.generalPanelTRI.columnBubbleLabel',
    defaultMessage: 'Column: Score TRI',
  },
});
